import types from '../actionTypes';

const INITIAL_STATE = {
  isFetchingParkingList: false,
  isFetchingSubjectUsers: false,
  isFetchingRoleUser: false,
  isCreating: false,
  isUpdating: false,
  isUpdatingState: false,

  parkingUsers: [],
  roleUsers: [],
  errors: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PARKING_EXT_ROLE_FETCH_ALL_REQUEST:
      return {
        ...state,
        isFetchingRoleUser: true,
      };
    case types.PARKING_EXT_ROLE_FETCH_ALL_SUCCESS:
      return {
        ...state,
        isFetchingRoleUser: false,
        roleUsers: action.payload.roleUsers,
      };
    case types.PARKING_EXT_ROLE_FETCH_ALL_FAIL:
      return {
        ...state,
        isFetchingRoleUser: false,
        errors: action.payload.error,
      };
    case types.PARKING_SUBJECT_EXT_USERS_FETCH_REQUEST:
      return {
        ...state,
        isFetchingSubjectUsers: true,
      };
    case types.PARKING_SUBJECT_EXT_USERS_FETCH_SUCCESS:
      return {
        ...state,
        isFetchingSubjectUsers: false,
        parkingUsers: action.payload.parkingUsers,
      };
    case types.PARKING_SUBJECT_EXT_USERS_FETCH_FAIL:
      return {
        ...state,
        isFetchingSubjectUsers: false,
        errors: action.payload.error,
      };
    case types.PARKING_EXT_USERS_FETCH_ALL_REQUEST:
      return {
        ...state,
        isFetchingParkingList: true,
      };
    case types.PARKING_EXT_USERS_FETCH_ALL_SUCCESS:
      return {
        ...state,
        isFetchingParkingList: false,
        parkingUsers: action.payload.parkingUsers,
      };
    case types.PARKING_EXT_USERS_FETCH_ALL_FAIL:
      return {
        ...state,
        isFetchingParkingList: false,
        errors: action.payload.error,
      };

    case types.PARKING_EXT_USER_CREATE_REQUEST:
      return {
        ...state,
        isCreating: true,
      };
    case types.PARKING_EXT_USER_CREATE_SUCCESS:
      return {
        ...state,
        isCreating: false,
        parkingUsers: action.payload.parkingUsers,
      };
    case types.PARKING_EXT_USER_CREATE_FAIL:
      return {
        ...state,
        isCreating: false,
        errors: action.payload.error,
      };
    case types.PARKING_EXT_USER_UPDATE_REQUEST:
      return {
        ...state,
        isUpdating: true,
      };
    case types.PARKING_EXT_USER_UPDATE_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        parkingUsers: action.payload.parkingUsers,
      };
    case types.PARKING_EXT_USER_UPDATE_FAIL:
      return {
        ...state,
        isUpdating: false,
        errors: action.payload.error,
      };
    case types.PARKING_EXT_USER_UPDATE_STATE_REQUEST:
      return {
        ...state,
        isUpdatingState: true,
      };
    case types.PARKING_EXT_USER_UPDATE_STATE_SUCCESS:
      return {
        ...state,
        isUpdatingState: false,
        parkingUsers: action.payload.parkingUsers,
      };
    case types.PARKING_EXT_USER_UPDATE_STATE_FAIL:
      return {
        ...state,
        isUpdatingState: false,
        errors: action.payload.error,
      };
    case types.PARKING_EXT_USER_SYNCH_REQUEST:
      return {
        ...state,
        isUpdating: true,
      };
    case types.PARKING_EXT_USER_SYNCH_SUCCESS:
      return {
        ...state,
        isUpdating: false,
      };
    case types.PARKING_EXT_USER_SYNCH_FAIL:
      return {
        ...state,
        isUpdating: false,
        errors: action.payload.error,
      };



    default:
      return state;
  }
};
